// Buba Pets cart add-ons (custom, added 2026-10-18). Markup: snippets/bp-cart-addons.liquid.
// One tap adds the variant through /cart/add.js, then hands the rendered cart sections to the
// theme through the standard CartLinesUpdateEvent (same flow as the theme's product form), so the
// cart drawer / cart page, the cart bubble and totals refresh without a page reload.

const MSG_ERROR = 'לא הצלחנו להוסיף את המוצר. אפשר לנסות שוב.';
const MSG_ADDED = 'נוסף לסל.';

let eventsModule = null;
async function loadEvents() {
  if (eventsModule) return eventsModule;
  try {
    eventsModule = await import('@shopify/events');
  } catch (error) {
    eventsModule = {};
  }
  return eventsModule;
}

function routes() {
  const r = (window.Theme && window.Theme.routes) || {};
  return {
    add: r.cart_add_url || '/cart/add.js',
    cart: (r.cart_url || '/cart') + '.js',
  };
}

function cartSectionIds() {
  const ids = [];
  for (const el of document.querySelectorAll('cart-items-component')) {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
  }
  return ids;
}

class BpCartAddons extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  setMessage(text) {
    const msg = this.querySelector('.bp-addons__msg');
    if (msg) msg.textContent = text;
  }

  onClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('button[data-bp-variant]') : null;
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    const variantId = button.dataset.bpVariant;
    const { CartLinesUpdateEvent } = await loadEvents();
    const url = routes();
    const sectionIds = cartSectionIds();

    button.setAttribute('aria-busy', 'true');
    this.setMessage('');

    let deferred = null;
    if (CartLinesUpdateEvent) {
      deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise,
        })
      );
    }

    try {
      const response = await fetch(url.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      const failed = !response.ok || Boolean(result.status);

      if (!deferred) {
        // Theme events unavailable: fall back to a full reload so the cart is always correct.
        if (!failed) window.location.reload();
        else this.setMessage(result.description || MSG_ERROR);
        return;
      }

      const cart = await fetch(url.cart, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'bp-cart-addons',
          itemCount: 1,
          sections: failed ? undefined : result.sections,
          didError: failed,
        },
      });
      this.setMessage(failed ? result.description || MSG_ERROR : MSG_ADDED);
    } catch (error) {
      if (deferred) deferred.reject(error);
      this.setMessage(MSG_ERROR);
    } finally {
      // The re-rendered cart usually replaces this button; re-enable it in case it stays.
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('bp-cart-addons')) customElements.define('bp-cart-addons', BpCartAddons);
